'use strict';
/**
 * This service loads a csv file, keeps the model and parses it
 * the communication with the backend to get/modify the persistent data.
 *
 */
angular.module('autoremind.csv.services', [])
    //angular.module('autoremind.services')
    .factory('csvImport', ['$rootScope', '$http', '$filter', 'logger', 'dialogs',
    function ($rootScope, $http, $filter, logger, dialogs) {
        var csvImport = null; // Initialize to avoid warnings in Eclipse
        csvImport = {
            fileName: "",
            inputFile: "",
            fieldSeparator: ',',
            fieldList: [],
            fileData: [],
            columnStatus: 0,
            type: 'choice',
            reset: function () {
                csvImport.fieldList = [];
                csvImport.fileData = [];
            },
            importAndParseFile: function (file, successCallback, failCallback) {
                logger.debug('csvImport.importAndParseFile( filename=' + file.name + ')...');
                var reader = null;
                //reader = new FileReader();
                if (window.File && window.FileReader && window.FileList && window.Blob) {
                    //document.write("<b>File API supported.</b>");
                    reader = new FileReader();
                }
                else {
                    dialogs.error('Error', 'File API not supported by this browser.');
                    return;
                    //reader = new moxie.file.FileReader();
                }
                csvImport.inputFile = file;
                reader.onload = function (event) {
                    var contents = event.target.result;
                    var array = csvImport.csvToArray(contents, csvImport.fieldSeparator);
                    logger.debug("File contents: " + contents);
                    var firstRowWithData = 0;
                    if (csvImport.type == 'uspi') {
                        // USPI does not have a header, so we'll create one with column numbers
                        firstRowWithData = 0;
                        csvImport.fieldList = [];
                        for (var i = 0; i < array[0].length; i++) {
                            csvImport.fieldList.push('' + (i));
                        }
                        logger.debug('csv fields: ' + csvImport.fieldList);
                    }
                    else if (csvImport.type == 'ederm') {
                        // eDerm files has a header (first line) with column names - use this for fieldList
                        firstRowWithData = 1;
                        //array = csvImport.csvToArray(contents, '\t');
                        logger.debug('csv ' + array[0] + ' array 0 ');
                        csvImport.fieldList = array[0];
                    }
                    else if (csvImport.type == 'edermold') {
                        array = csvImport.csvToArray(contents, '\t');
                        csvImport.fieldList = array[4];
                        firstRowWithData = 5;
                        //			    	} else if (csvImport.type == 'choice') {
                    }
                    else {
                        // Practice Choice has a header (first line) with column names - use this for fieldList
                        firstRowWithData = 1;
                        logger.debug('csv ' + array[0] + ' array 0 ');
                        csvImport.fieldList = array[0];
                    }
                    // Add extra columns for extra info not in the CSV file
                    csvImport.columnStatus = array[0].length;
                    csvImport.columnStatusDetail = array[0].length + 1;
                    csvImport.columnDuplicateState = [];
                    csvImport.columnDuplicateState[1] = array[0].length + 2;
                    csvImport.columnDuplicateState[2] = array[0].length + 3;
                    csvImport.fileData = [];
                    for (var i = firstRowWithData; i < array.length; i++) {
                        array[i][csvImport.columnStatus] = 'Unscheduled';
                        array[i][csvImport.columnStatusDetail] = '';
                        array[i][csvImport.columnDuplicateState[1]] = 'false';
                        array[i][csvImport.columnDuplicateState[2]] = 'false';
                        logger.debug('csv line' + i + ' ' + array[i][0] + ' ');
                        // Filter phone numbers
                        var twoNumbers = angular.isDefined(csvImport.columnDestinatorPhone[2]);
                        console.log('csvImport.phoneNumberFilter', array[i], array[i][csvImport.columnDestinatorPhone[1]], csvImport.countryPhonePrefix);
                        var phone1 = $filter(csvImport.phoneNumberFilter)(array[i][csvImport.columnDestinatorPhone[1]], csvImport.countryPhonePrefix);
                        array[i][csvImport.columnDestinatorPhone[1]] = phone1;
                        if (twoNumbers) {
                            var phone2 = $filter(csvImport.phoneNumberFilter)(array[i][csvImport.columnDestinatorPhone[2]], csvImport.countryPhonePrefix);
                            array[i][csvImport.columnDestinatorPhone[2]] = phone2;
                        }
                        csvImport.fileData.push(array[i]);
                    }
                    // Check for duplicate destinator
                    for (var i = firstRowWithData; i < array.length; i++) {
                        for (var j = firstRowWithData; j < array.length; j++) {
                            if (i != j && array[i][csvImport.columnDestinatorPhone[1]] == array[j][csvImport.columnDestinatorPhone[1]] && array[i][csvImport.columnDestinatorPhone[1]] != '') {
                                //logger.debug('duplicate i: ' + array[i][csvImport.columnDestinatorPhone[1]] );
                                array[i][csvImport.columnDuplicateState[1]] = 'true';
                            }
                            if (i != j && array[i][csvImport.columnDestinatorPhone[2]] == array[j][csvImport.columnDestinatorPhone[2]] && array[i][csvImport.columnDestinatorPhone[2]] != '') {
                                //logger.debug('duplicate i: ' + array[i][csvImport.columnDestinatorPhone[2]] );
                                array[i][csvImport.columnDuplicateState[2]] = 'true';
                                logger.debug('duplicate:' + array[j][csvImport.columnDestinatorPhone[2]] + '#');
                            }
                            if (i != j && array[i][csvImport.columnDestinatorPhone[1]] == array[j][csvImport.columnDestinatorPhone[2]] && array[i][csvImport.columnDestinatorPhone[1]] != '') {
                                //logger.debug('duplicate i: ' + array[i][csvImport.columnDestinatorPhone[1]] );
                                array[i][csvImport.columnDuplicateState[1]] = 'true';
                            }
                            if (i != j && array[i][csvImport.columnDestinatorPhone[2]] == array[j][csvImport.columnDestinatorPhone[1]] && array[i][csvImport.columnDestinatorPhone[2]] != '') {
                                //logger.debug('duplicate i: ' + array[i][csvImport.columnDestinatorPhone[2]] );
                                array[i][csvImport.columnDuplicateState[2]] = 'true';
                                logger.debug('duplicate:' + array[j][csvImport.columnDestinatorPhone[2]] + '#');
                            }
                        }
                    }
                    // Only do something if the callback is in fact a function
                    if (successCallback && typeof (successCallback) === "function") {
                        successCallback(); //Async callback
                    }
                };
                reader.onerror = function (event) {
                    logger.error("File could not be read! Code " + event.target.error.code);
                    // Only do something if the callback is in fact a function
                    if (failCallback && typeof (failCallback) === "function") {
                        failCallback(); //Async callback
                    }
                };
                reader.readAsText(file);
                logger.debug('csv end');
            },
            csvToArray: function (strData, strDelimiter) {
                // Check to see if the delimiter is defined. If not,
                // then default to comma.
                strDelimiter = (strDelimiter || ",");
                var objPattern = new RegExp((
                // Delimiters.
                "(\\" + strDelimiter + "|\\r?\\n|\\r|^)" +
                    // Quoted fields.
                    "(?:\"([^\"]*(?:\"\"[^\"]*)*)\"|" +
                    // Standard fields.
                    "([^\"\\" + strDelimiter + "\\r\\n]*))"), "gi");
                // Create an array to hold our data. Give the array
                // a default empty first row.
                var arrData = [[]];
                // Create an array to hold our individual pattern
                // matching groups.
                var arrMatches = null;
                // Keep looping over the regular expression matches
                // until we can no longer find a match.
                while (arrMatches = objPattern.exec(strData)) {
                    // Get the delimiter that was found.
                    var strMatchedDelimiter = arrMatches[1];
                    // Check to see if the given delimiter has a length
                    // (is not the start of string) and if it matches
                    // field delimiter. If id does not, then we know
                    // that this delimiter is a row delimiter.
                    if (strMatchedDelimiter.length &&
                        (strMatchedDelimiter != strDelimiter)) {
                        // is last array empty
                        if (arrData.length > 0) {
                            var isEmpty = true;
                            for (var i = 0; i < arrData[arrData.length - 1].length; i++) {
                                if (arrData[arrData.length - 1][i] != "")
                                    isEmpty = false;
                            }
                            if (isEmpty)
                                arrData.pop();
                        }
                        // Since we have reached a new row of data,
                        // add an empty row to our data array.
                        arrData.push([]);
                    }
                    // Now that we have our delimiter out of the way,
                    // let's check to see which kind of value we
                    // captured (quoted or unquoted).
                    var strMatchedValue = "";
                    if (arrMatches[2]) {
                        // We found a quoted value. When we capture
                        // this value, unescape any double quotes.
                        strMatchedValue = arrMatches[2].replace(new RegExp("\"\"", "g"), "\"");
                    }
                    else {
                        // We found a non-quoted value (empty quoted values are NOT matched as quoted value and the non-quoted (argument 3) is undefined).
                        if (arrMatches[3] === undefined)
                            strMatchedValue = '';
                        else
                            strMatchedValue = arrMatches[3];
                    }
                    // Now that we have our value string, let's add
                    // it to the data array.
                    arrData[arrData.length - 1].push(strMatchedValue);
                }
                // Return the parsed data.
                // is last array empty
                if (arrData.length > 0) {
                    var isEmpty = true;
                    for (var i = 0; i < arrData[arrData.length - 1].length; i++) {
                        if (arrData[arrData.length - 1][i] != "")
                            isEmpty = false;
                    }
                    if (isEmpty)
                        arrData.pop();
                }
                return (arrData);
            }
        };
        return csvImport;
    }]);
//# sourceMappingURL=csvImport.service.js.map